import React, { ComponentPropsWithoutRef } from "react";
import Image from "react-bootstrap/Image";
import { useNavigate } from "react-router-dom";

import BackButton from "../../../images/left-arrow-white.svg";
import "./OnboardingHeader.scss";

interface IOnboardingHeaderProps extends ComponentPropsWithoutRef<"div"> {
  amountActive?: number;
  onClick?: () => void;
  steps?: number;
  showProgress?: boolean;
}

type IDashedComponentProps = {
  amountActive: number;
  steps: number;
};

function OnboardingHeaderDashedComponent({ value }: { value: boolean }) {
  const backgroundColor: string = value ? "#F4F0FF36" : "#6C53E8";
  return (
    <div
      className="OnboardingDashedComponent mx-1"
      style={{ background: backgroundColor }}
    />
  );
}

function DashedProgress({ amountActive, steps }: IDashedComponentProps) {
  return (
    <>
      {new Array(steps).fill("_").map((item, i) => (
        <OnboardingHeaderDashedComponent key={i} value={i >= amountActive} />
      ))}
    </>
  );
}

function OnboardingHeader({
  amountActive,
  onClick,
  steps = 2,
  showProgress = true,
  className = "",
  ...props
}: IOnboardingHeaderProps) {
  const navigate = useNavigate();

  const back = () => {
    navigate(-1);
  };

  return (
    <div className={`OnboardingHeader ${className}`} {...props}>
      <button className="OnboardingHeaderBackButton" onClick={back}>
        <Image src={BackButton} alt="go back" />
      </button>
      {showProgress && amountActive && (
        <>
          <div
            className="OnboardingDashedComponentContainer"
            aria-label="Progress"
            role="progressbar"
            aria-valuemin={1}
            aria-valuemax={steps}
            aria-valuenow={amountActive}
          >
            <DashedProgress amountActive={amountActive} steps={steps} />
          </div>
          <p className="OnboardingStepCounter">
            {amountActive}/{steps}
          </p>
        </>
      )}
    </div>
  );
}

export default OnboardingHeader;
